// TODO: This entire file is deprecated and should be removed
// TODO: Journal validation, filtering, and calculations are now handled by the API
// TODO: All functions in this file are replaced by corresponding API endpoints:
// TODO: - validateJournalEntry -> Server-side validation in POST /accounting/journals/create
// TODO: - calculateJournalTotals -> Included in API responses
// TODO: - filterJournalEntries -> Handled by POST /accounting/journals/list with filters
// TODO: - sortJournalEntries -> Handled by API sortField/sortOrder parameters
// TODO: - All other functions -> Replaced by real API calls

import {
  IJournalEntryListItem,
  IJournalDetailsData,
} from "../accounting.interface";
import moment from "moment";

/**
 * @deprecated Use server-side validation via API endpoints
 * TODO: Remove this function - validation is now handled by the backend
 */
export const validateJournalEntry = (
  entry: any // TODO: Remove when function is deleted
): { isValid: boolean; errors: string[] } => {
  // TODO: This function is deprecated - use API validation instead
  const errors: string[] = [
    "This function is deprecated - use API validation instead",
  ];
  return {
    isValid: false,
    errors,
  };
};

/**
 * @deprecated Totals are now included in API responses
 * TODO: Remove this function - totals are calculated by the backend
 */
export const calculateJournalTotals = (entry: any) => {
  // TODO: This function is deprecated - totals are included in API responses
  return {
    totalDebits: 0,
    totalCredits: 0,
    isBalanced: false,
  };
};

/**
 * @deprecated Use API filtering via POST /accounting/journals/list
 * TODO: Remove this function - filtering is now handled by the API
 */
export const filterJournalEntries = (entries: any[], filters: any) => {
  // TODO: This function is deprecated - use API filtering instead
  console.warn(
    "filterJournalEntries is deprecated - use API filtering instead"
  );
  return entries;
};

/**
 * @deprecated Use API sorting via sortField/sortOrder parameters
 * TODO: Remove this function - sorting is now handled by the API
 */
export const sortJournalEntries = (
  entries: any[],
  sortBy: any,
  sortOrder: "asc" | "desc" = "desc"
) => {
  // TODO: This function is deprecated - use API sorting instead
  console.warn("sortJournalEntries is deprecated - use API sorting instead");
  return entries;
};

/**
 * @deprecated Use API to generate journal IDs
 * TODO: Remove this function - ID generation is handled by the backend
 */
export const generateJournalEntryId = (
  existingEntries: any[],
  year?: number
): string => {
  // TODO: This function is deprecated - ID generation is handled by the backend
  console.warn(
    "generateJournalEntryId is deprecated - IDs are generated by the backend"
  );
  return "DEPRECATED";
};

/**
 * @deprecated Use API ledger endpoints
 * TODO: Remove this function - use GET /accounting/ledger/entries instead
 */
export const getJournalEntriesForAccount = (
  entries: any[],
  accountId: string
): any[] => {
  // TODO: This function is deprecated - use API ledger endpoints instead
  console.warn(
    "getJournalEntriesForAccount is deprecated - use API ledger endpoints instead"
  );
  return [];
};

/**
 * @deprecated Use API ledger balance calculations
 * TODO: Remove this function - use GET /accounting/ledger/summary instead
 */
export const calculateAccountBalance = (
  entries: any[],
  accountId: string,
  asOfDate?: string
): { debits: number; credits: number; balance: number } => {
  // TODO: This function is deprecated - use API ledger balance calculations instead
  console.warn(
    "calculateAccountBalance is deprecated - use API ledger endpoints instead"
  );
  return { debits: 0, credits: 0, balance: 0 };
};

/**
 * @deprecated Use API journal statistics
 * TODO: Remove this function - statistics are provided by the API
 */
export const getJournalSummaryStats = (entries: any[]) => {
  // TODO: This function is deprecated - statistics are provided by the API
  console.warn(
    "getJournalSummaryStats is deprecated - use API statistics instead"
  );
  return {};
};

/**
 * @deprecated Use API reversal endpoints
 * TODO: Remove this function - use POST /accounting/journals/reverse instead
 */
export const createReversalEntry = (
  originalEntry: any,
  reversalReason: string,
  userId: string
): any => {
  // TODO: This function is deprecated - use API reversal endpoints instead
  console.warn(
    "createReversalEntry is deprecated - use API reversal endpoints instead"
  );
  return {};
};

/**
 * @deprecated Use API ledger entry endpoints
 * TODO: Remove this function - use GET /accounting/ledger/entries instead
 */
export const getLedgerEntriesForAccount = (
  entries: any[],
  accountId: string,
  openingBalance: number = 0,
  includeOpeningBalance: boolean = true
) => {
  // TODO: This function is deprecated - use API ledger entry endpoints instead
  console.warn(
    "getLedgerEntriesForAccount is deprecated - use API ledger endpoints instead"
  );
  return [];
};
